import { LanguageOptions, Vendor } from '../types';

export default class Language {
  id: string;
  extensions: string[];
  filenames?: string[];
  vendorMap: { [key in Vendor]: string };

  constructor(id: string, options: LanguageOptions) {
    this.id = id;
    this.extensions = options.extensions;
    this.filenames = options.filenames;
    this.vendorMap = {
      monaco: this.vendorDefault('monaco', options),
      prism: this.vendorDefault('prism', options),
    };
  }

  vendorDefault(vendor: Vendor, options?: LanguageOptions) {
    return options && options.vendorOverride
      ? options.vendorOverride[vendor] || this.id
      : this.id;
  }

  get monaco() {
    return this.vendorMap.monaco;
  }

  get prism() {
    return this.vendorMap.prism;
  }
}
